export enum DiagnosticType {
    None = 0,
    BHDiagnostic = 1,
    PHDiagnostic = 2,
}
